module.exports = __webpack_public_path__ + "static/img/bg-id.03b467d2.webp";